import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';

import styles from '../ActivityReportsComponent/ActivityReportsComponent.module.scss';
import './MLMigrationsReportComponent.messages';
import metadata from './MLMigrationsReportComponent.metadata.json5';

import React from 'react';

// TODO: ML malarie US10194 - replace with correct call to backend service once Migrations have been defined - link to this page will be hidden until then

// MLMigrationsReportDirectiveCtrl
const MLMigrationsReportComponent = (props) => {
    const {
        rowLimit,
        isDashboard,
        history
    } = props;
    const translator = useTranslator();

    const { authHeader } = useAuthentication();

    const renderRenewalDateCell = (item) => {
    };

    const renderCustomerName = (item) => {
    };

    const renderNewPolicyTypeCell = (item) => {
    };

    const renderNewPolicyCell = (item) => {
    };

    const renderNewPremiumCell = (item) => {
    };

    const onViewAllChangesButtonClicked = () => {
        const reportView = 'migrations-report';
        history.push('/activity-reports', {reportView : reportView} );
    }

    const overrideProps = {
        migrationsReportTable: {
            // data: _.orderBy(filteredJobs, 'closeDate', 'asc'),
            // visible: !isLoading,
            // defaultPageSize: rowLimit,
            // noDataText: translator(messages.noPolicyMigrationsFound),
            // showPagination: false
        },
        viewAllMigrationsButton: {
            visible: isDashboard,
            onClick: onViewAllChangesButtonClicked,
            mlTagManagerLinkClick: "Dashboard_activityReport_viewAll_migrations"
        },
        renewalDateColumn: {
            headerClassName: "reportHeader"
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            renderRenewalDateCell,
            renderCustomerName,
            renderNewPolicyTypeCell,
            renderNewPolicyCell,
            renderNewPremiumCell
        },
        resolveClassNameMap: styles
    };
    
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLMigrationsReportComponent.propTypes = {
    rowLimit: PropTypes.number.isRequired,
    isDashboard: PropTypes.bool.isRequired,
    history: PropTypes.shape({push: PropTypes.func}).isRequired,
}

export default withRouter(MLMigrationsReportComponent);
